import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from "@angular/forms";

@Component({
    selector: 'app-sms-content-input',
    templateUrl: './sms-content-input.component.html',
})
export class SmsContentInputComponent implements OnInit {

    @Input() maxLength = 140;
    @Input() parentFormGroup: FormGroup;
    @Input() parentFormGroupName: string;

    constructor() {
    }

    ngOnInit() {
    }

}
